import React from 'react';
import api from '@e74/services/ApiConfig';
import {
  GET_DASHBOARD_DATA,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
} from '../../../shared/constants/ActionTypes';
import IntlMessages from '@e74/utility/IntlMessages';

export const onGetDashboardData = () => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START});
    api
      .patientdashboard()
      .fetchAll(getState().doctor.id || null)
      .then((data) => {
        if (data.status === 200) {
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: GET_DASHBOARD_DATA, payload: data.data});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: <IntlMessages id='message.somethingWentWrong' />,
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};
